import React, { useEffect, useState } from 'react'
import { getAllOrders, orderApproval } from 'api/order'
import OrderList from './OrderList'
import Loading from 'components/common/Loading'

const PageByStatus = props => {
  const [listOrder, setListOrder] = useState([])
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [selectedOrder, setSelectedOrder] = useState([])
  const [isSelectAll, setIsSelectAll] = useState(false)
  const [loadingApproval, setLoadingApproval] = useState(false)

  const handleGetAllOrders = async () => {
    try {
      const params = {
        page: 1,
        limit: 100,
        status: props.status
      }

      if (props.status === 'COMPLETED') {
        params['order'] = 'received_at'
        params['sort'] = 'desc'
      }

      const response = await getAllOrders(params)
      if (response && response.data) {
        setListOrder(response.data)
      } else {
        setIsError(true)
      }
    } catch (error) {
      setIsError(true)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    handleGetAllOrders()
  }, [])

  const handleSelectOrder = orderId => {
    const index = selectedOrder.indexOf(orderId)
    if (index === -1) {
      setSelectedOrder([...selectedOrder, orderId])
    } else {
      const newSelected = [...selectedOrder]
      newSelected.splice(index, 1)
      setSelectedOrder(newSelected)
    }
  }

  const handleSelectAll = () => {
    if (isSelectAll) {
      setSelectedOrder([])
    } else {
      const allOrderIds = listOrder.map(order => order.order.id)
      setSelectedOrder(allOrderIds)
    }
    setIsSelectAll(!isSelectAll)
  }

  const handleApproval = async isApprove => {
    setLoadingApproval(true)

    const approvalPromises = selectedOrder.map(async orderId => {
      const selectedOrder = listOrder.find(order => order.order.id === orderId)
      const payload = {
        order_id: orderId,
        status: isApprove,
        note: '',
        order_items: selectedOrder.order_items.map(item => ({
          order_item_id: item.order_item.id,
          status: isApprove,
          note: ''
        }))
      }
      return orderApproval(payload)
    })

    await Promise.all(approvalPromises)

    setLoadingApproval(false)
    setSelectedOrder([])
    setIsSelectAll(false)
    setIsLoading(true)
    handleGetAllOrders()
  }

  useEffect(() => {
    if (props.isSelectAll) {
      const allOrderIds = listOrder.map(order => order.order.id)
      setSelectedOrder(allOrderIds)
    } else {
      setSelectedOrder([])
    }
  }, [props.isSelectAll])

  useEffect(() => {
    if (selectedOrder.length === listOrder.length) {
      setIsSelectAll(true)
    } else {
      setIsSelectAll(false)
    }
  }, [selectedOrder, listOrder])

  return (
    <>
      {loadingApproval && (
        <div
          style={{
            background: 'rgba(0,0,0,0.3)',
            width: '100%',
            height: '100vh',
            position: 'fixed',
            zIndex: 9999,
            left: 0,
            top: 0
          }}
        >
          <Loading />
        </div>
      )}
      <OrderList
        listOrder={listOrder}
        status={props.status}
        showDetail={props.showDetail}
        isError={isError}
        isLoading={isLoading}
        selectedOrder={selectedOrder}
        setSelectedOrder={handleSelectOrder}
        isSelectAll={isSelectAll}
        setIsSelectAll={handleSelectAll}
        onApproval={handleApproval}
      />
    </>
  )
}

export default PageByStatus
